import { render, staticRenderFns } from "./ImageAssetWidgetComponent.vue?vue&type=template&id=0108518d&"
import script from "./ImageAssetWidgetComponent.vue?vue&type=script&lang=js&"
export * from "./ImageAssetWidgetComponent.vue?vue&type=script&lang=js&"
import style0 from "./ImageAssetWidgetComponent.vue?vue&type=style&index=0&id=0108518d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports